export default __webpack_public_path__ + "static/GT-America-Standard-Light-03f9904fd750ec1e306e3c16404d26a5.woff";